<template>
  <div class="user-roles__bg">
    <div class="user-roles__bg-content">
      <div class="user-roles__bg-content__row">
        <user-card :content="$t('user-card:create:text')" />
      </div>
      <div class="user-roles__bg-content__row">
        <r-text>{{ $t("user-card:hint-create") }}</r-text>
      </div>
      <div class="user-roles__bg-content__row">
        <user-card :user="userTemplate" />
      </div>
      <div class="user-roles__bg-content__row">
        <r-text>{{ $t("user-card:hint-select") }}</r-text>
      </div>
    </div>
  </div>
</template>

<script>
import userCard from "../renderers/user-roles-user-card";

const userTemplate = {
  name: "IvanIvanov",
  position: "Дизайнер"
};

export default {
  components: { userCard },
  data() {
    return {
      userTemplate
    };
  }
};
</script>

<style lang="scss">
.user-roles__bg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 48px;
  box-sizing: border-box;
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 320px;
    text-align: center;
    &__row {
      margin-bottom: 16px;
      &:nth-child(2) {
        margin-bottom: 32px;
      }
      .r-text,
      .r-text.caption-2 {
        color: var(--text_secondary) !important;
      }
    }
  }

  .user-card__wrapper {
    &:hover {
      border-color: var(--dividers_low_contrast) !important;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "user-card:create:text": "Создать новый аккаунт",
    "user-card:hint-create": "Чтобы создать пользователя нажмите вверху списка «Создать новый аккаунт»",
    "user-card:hint-select": "Чтобы изменить данные существующего пользователя найдите его в списке и нажмите на его карточку"
  },
  "en": {
    "user-card:create:text": "Create new account",
    "user-card:hint-create": "To create new user, click \"Create new account\" at the top of the list",
    "user-card:hint-select": "To edit data of an existing user, find him in the list and click on his card"
  }
}
</i18n>
